var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAdmin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.002 13.465c-1.964 0-3.562-1.554-3.562-3.465 0-1.91 1.598-3.465 3.562-3.465 1.965 0 3.562 1.554 3.562 3.465 0 1.91-1.597 3.465-3.562 3.465zm7.562-2.495c.041-.317.072-.633.072-.97 0-.337-.031-.653-.072-.97l2.148-1.634a.49.49 0 00.122-.633l-2.036-3.426c-.122-.218-.397-.297-.62-.218l-2.535.99a7.489 7.489 0 00-1.72-.97L12.537.516a.492.492 0 00-.5-.416h-4.07a.492.492 0 00-.499.416l-.387 2.623c-.62.248-1.19.584-1.72.97l-2.534-.99a.503.503 0 00-.62.218L.17 6.763a.48.48 0 00.122.633L2.44 9.03a7.64 7.64 0 00-.071.97c0 .327.03.653.071.97L.293 12.604a.49.49 0 00-.122.633l2.035 3.425c.122.219.397.298.621.219l2.534-.99c.53.396 1.1.722 1.72.97l.387 2.623c.03.237.244.416.499.416h4.07c.255 0 .469-.18.5-.416l.386-2.623a7.875 7.875 0 001.72-.97l2.535.99c.234.089.498 0 .62-.22l2.036-3.424a.49.49 0 00-.122-.633l-2.148-1.634z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdmin);
export default __webpack_public_path__ + "static/media/icon_admin.4ec4e0d7da0f79e72f9c43e4920219ae.svg";
export { ForwardRef as ReactComponent };